
export default function LoadMore({ loadMore }) {
    return async params => {
        const { queryName } = params
        if(loadMore) {
            loadMore(queryName)
        }
    }
}